var React = require('react');

function ArrowNortheast (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.57836 3.21409L4.09761 3.21409C3.68201 3.21409 3.34433 3.55177 3.34433 3.96738C3.34433 4.38298 3.68201 4.72066 4.09761 4.72066L6.88996 4.72066L2.83781 8.77282C2.53909 9.05855 2.53909 9.53909 2.83131 9.83131C3.12354 10.1235 3.60408 10.1235 3.8963 9.83131L7.94846 5.77916L7.94196 8.56501C7.94196 8.98062 8.27964 9.3183 8.69525 9.3183C8.90305 9.3183 9.09137 9.23388 9.22774 9.09751C9.36411 8.96114 9.44853 8.77282 9.44853 8.56501V4.08427C9.44853 3.85049 9.35762 3.6297 9.19527 3.46735C9.03293 3.30501 8.81214 3.21409 8.57836 3.21409Z","fill":"black"}));
}

ArrowNortheast.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = ArrowNortheast;

ArrowNortheast.default = ArrowNortheast;
